import { Chip, FormControl, InputLabel, MenuItem, Select, SxProps, Theme } from "@mui/material";
import { CSSProperties, useState } from "react";
import { CsmText } from "../../library/components/mui/CsmText";
import Columns from "../../library/components/layout/Columns";
import { KadroModel } from "../../models/businessModels/KadroModel";
import StringHelper from "../../library/helpers/StringHelper";
import Rows from "../../library/components/layout/Rows";

export interface IVatanKadroSelectFieldProps {
    id?: string,
    value: string | null,
    label: string,
    tumKadrolar: KadroModel[],
    onChange: (e: string) => void,
    error?: boolean,
    fontSize?: number,
    sx?: SxProps<Theme>,
    style?: CSSProperties,
    disabled?: boolean,
}

export default function VatanKadroSelectField(props: IVatanKadroSelectFieldProps) {
    const { id, value, label, tumKadrolar, onChange, error, fontSize, sx, disabled, style } = props;
    const fontSizeToUse = fontSize ?? 14;
    const [open, setOpen] = useState(false);

    const list = (tumKadrolar ?? []).orderByTurkish(e => e.isim);

    const chipClicked = (newId: string) => {
        if (value !== newId)
            onChange(newId);
        handleClose();
    }

    const getChipMenuItem = (kadro: KadroModel, isSelected: boolean): React.ReactNode => {
        return <Chip
            key={kadro.id}
            label={kadro.isim}
            onClick={() => { chipClicked(kadro.id) }}
            color={isSelected ? "primary" : undefined}
            style={{ margin: "5px", cursor: "pointer", display: "flex" }}
        />;
        // return <MenuItem style={{ display: "flex" }} key={sezon.id} value={sezon.id}>
        //     <Chip style={{ display: "flex"}} key={sezon.id} label={sezon.isim} />
        // </MenuItem>
    }

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    return (
        <FormControl fullWidth style={{ marginTop: 0, ...style }}>
            <InputLabel error={error} id={"label" + label}>{label}</InputLabel>
            <Select
                defaultValue=""
                open={open}
                onClose={handleClose}
                onOpen={handleOpen}
                native={false}
                disabled={disabled}
                sx={sx}
                inputProps={{ style: { paddingTop: "5px !important", paddingBottom: "5px !important", fontSize: fontSizeToUse } }}
                error={error}
                labelId={id}
                MenuProps={{ MenuListProps: { style: { display: "flex", flexWrap: "wrap" } } }}
                id={id}
                value={StringHelper.nullToEmpty(value)}
                label={label}
                renderValue={() => <CsmText style={{ overflow: "hidden" }}>{list.singleOrDefault(e => e.id === value)?.isim}</CsmText>}
                onChange={(e) => { onChange(e.target.value); }}>
                {list.map(e => <MenuItem key={e.id} value={e.id} style={{ display: "none" }} />)}
                <Rows flex>
                    <Rows mb={10}>
                        <CsmText style={{ marginLeft: "10px" }} note>Aktif Kadrolar</CsmText>
                        <MenuItem style={{ padding: "0px" }} divider></MenuItem>
                        <Columns flex wrap>
                            {list.where(e => e.aktif).map(e => getChipMenuItem(e, e.id === value))}
                        </Columns>
                    </Rows>
                    <Rows mb={10}>
                        <CsmText style={{ marginLeft: "10px" }} note>Pasif Kadrolar</CsmText>
                        <MenuItem style={{ padding: "0px" }} divider></MenuItem>
                        <Columns flex wrap>
                            {list.where(e => !e.aktif).map(e => getChipMenuItem(e, e.id === value))}
                        </Columns>
                    </Rows>
                </Rows>

            </Select>
        </FormControl>
    );
}
